// Wizard-specific logging utility

interface LogData {
  [key: string]: any;
}

class WizardLogger {
  private enabled: boolean;
  private prefix = '[WIZARD]';

  constructor(enabled: boolean = true) {
    this.enabled = enabled;
  }

  private formatLog(action: string, data?: LogData) {
    return {
      action,
      timestamp: new Date().toISOString(),
      ...data
    };
  }

  log(action: string, data?: LogData) {
    if (!this.enabled) return;
    console.log(this.prefix, this.formatLog(action, data));
  }

  error(action: string, error: Error, data?: LogData) {
    if (!this.enabled) return;
    console.error(this.prefix, 'ERROR:', this.formatLog(action, {
      error: error.message,
      stack: error.stack,
      ...data
    }));
  }

  warn(action: string, data?: LogData) {
    if (!this.enabled) return;
    console.warn(this.prefix, 'WARNING:', this.formatLog(action, data));
  }

  // Log step transitions
  stepTransition(from: string, to: string, direction: 'next' | 'back' | 'jump') {
    this.log('stepTransition', { from, to, direction });
  }

  // Log form data changes
  formDataChange(step: string, field: string, value: any) {
    this.log('formDataChange', { step, field, value });
  }

  // Log validation results
  validation(step: string, isValid: boolean, errors?: string[]) {
    this.log('validation', { step, isValid, errors });
  }

  // Log feature flag status
  featureFlag(enabled: boolean) {
    this.log('featureFlag', { wizardEnabled: enabled });
  }

  // Log performance metrics
  performance(action: string, duration: number) {
    this.log('performance', { action, durationMs: duration });
  }
}

// Create singleton instance
export const wizardLogger = new WizardLogger(
  process.env.NODE_ENV === 'development'
);

// Export type for use in components
export type { WizardLogger };
